import { useThemeStore } from '@/stores/theme'
import { watchSystemColorScheme } from '@/utils/systemColorScheme'

let detachListener: (() => void) | null = null

/**
 * Attaches or removes the prefers-color-scheme listener based on theme store state.
 */
export function syncSystemColorSchemeListener(): void {
  detachListener?.()
  detachListener = null

  const store = useThemeStore()
  if (!store.followSystemColorScheme) return

  detachListener = watchSystemColorScheme(() => {
    store.syncFromSystemPreference()
  })
}
